import { Route } from "react-router-dom";
import { ProjectLayout } from "../layouts/ProjectLayout";
import { PROJECTS, layoutConfigs } from "../layouts/layoutConfig";
import {
  Intro,
  Home,
  About,
  Music,
  Video,
  Gigs,
  Contact,
  Mix,
  Merch,
  ReleaseDetails,
} from "../pages";

export const getRoutesConfig = (project) => {
  const isHBproject = project === "hardcorebuddhist";
  const routesConfig = [
    { path: "/", page: Intro },
    { path: `/${project}`, label: "Home", page: Home },
    { path: `/${project}/discography`, label: "Discography", page: Music },
    { path: `/${project}/discography/:id`, label: null, page: ReleaseDetails },
    { path: `/${project}/mixes`, label: "Mixes", page: Mix },
    { path: `/${project}/videos`, label: "Videos", page: Video },
    { path: `/${project}/gigs`, label: "Gigs", page: Gigs },
    ...(isHBproject
      ? [{ path: `/${project}/merch`, label: "Merch", page: Merch }]
      : []),
    { path: `/${project}/about`, label: "About", page: About },
    { path: `/${project}/contact`, label: "Contact", page: Contact },
  ];

  return routesConfig;
};

export const renderProjectRoutes = ({ pathname, isMobile }) => {
  return Object.values(PROJECTS).flatMap((project) => {
    const routesConfig = getRoutesConfig(project);

    return routesConfig.map(({ path, page: Page }) => (
      <Route
        key={path}
        path={path}
        element={
          <ProjectLayout
            project={project}
            config={layoutConfigs[project]}
            isMobile={isMobile}
            pathname={pathname}
          >
            <Page
              project={project}
              config={layoutConfigs[project]}
              isMobile={isMobile}
              pathname={pathname}
            />
          </ProjectLayout>
        }
      />
    ));
  });
};
